module.exports = {
  spacingXsmall: "4px",
  spacingSmall: "8px",
  spacingMedium: "16px",
  spacingLarge: "32px",
  spacingXlarge: "48px",
  spacingXxlarge: "64px",
};